import { render, staticRenderFns } from "./ShiftSwapReviewDialog.vue?vue&type=template&id=bf82b26e&"
import script from "./ShiftSwapReviewDialog.vue?vue&type=script&lang=ts&"
export * from "./ShiftSwapReviewDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports